import { throttle } from "lodash";
import * as React from "react";
import { If } from "../../../../core/components/If";
import { DISTRIBUTION_SUB_TYPE_LOOKUP, DISTRIBUTION_TYPE_LOOKUP } from "../../../../lookup/Consts";
import { ILookupInstance } from "../../../../lookup/types/ILookup";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { hideModal, showModal, showYesNoPrompt, showUpdateFieldsModal, showScheduledJobModalView } from "../../../../redux/reducers/ModalReducer";
import { addDroppedFile, clearModalSearchResults, copyExistingDistribution, setEditableFields, sortDistributionPoolFieldData, updateDistributionField, updateScheduledJobField } from "../../../../redux/reducers/RepertoireReducer";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { IDistributionState } from "../../../../redux/types/IDistributionState";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { ITriggerManualJob } from "../../../../redux/types/ITriggerManualJob";
import { ALL_ROLES, EMPTY_STRING_VALUE, EVENT_HANDLER_THROTTLE_TIME, UPDATE_DISTRIBUTIONS_ROLE } from "../../../Consts";
import { IDataActionToolbar } from "../../../types/IDataActionToolbar";
import { ITreeData } from "../../../types/ITreeData";
import { IDistributionType } from "../../../types/usageTypes/IDistibutionType";
import { ILastPercentageSearchQuery } from "../../../types/usageTypes/ILastPercentageSearchQuery";
import { IUsagePool } from "../../../types/usageTypes/IUsagePool";
import { IUsagePoolSearchQuery } from "../../../types/usageTypes/IUsagePoolSearchQuery";
import { DistributionMaintenanceGeneralDataView } from "../distributionMaintenanceGeneralDataView/DistributionMaintenanceGeneralDataView";
import { DistributionMaintenanceGridsView } from "../distributionMaintenanceGridsView/DistributionMaintenanceGridsView";
import { DistributionMaintenanceToolbar } from "../distributionMaintenanceToolbar/DistributionMaintenanceToolbar";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { IDistributionSubType } from "../../../types/usageTypes/IDistributionSubType";
import { IScheduledJobState } from "../../../../redux/types/IScheduledJobState";
import { IResultsPerPage } from "../../../../redux/types/IResultsPerPage";
import { IActiveAccordion } from "../../../../redux/types/IActiveAccordion";


export interface IDistributionMaintenancePageProps {
    distributionMaintenanceGeneralDataViewData: IRepertoireComponentDataItem;
    scheduledJobModalViewData?: IRepertoireComponentDataItem;
    distributionMaintenanceToolbarData?: IRepertoireComponentDataItem;
    distributionMaintenanceSaveResultData?: IRepertoireComponentDataItem;
    distributionMaintenanceGridsViewData?: IRepertoireComponentDataItem;
    dataGridTableData?: IRepertoireComponentDataItem;
    distribution: IDistributionState;
    schedule?: IScheduledJobState[];
    activeTab: number;
    tabs: ITabReduxItem[];
    lookupValues: ILookupDictionary;
    distributionTypes: IDistributionType[];
    distributionSubTypes: IDistributionSubType[];
    hideModal: typeof hideModal;
    showYesNoPrompt: typeof showYesNoPrompt;
    showScheduledJobModalView: typeof showScheduledJobModalView;
    resetMessageBanner: () => void;
    addNewDistribution: (lookupValues: ILookupDictionary, isNew?: boolean, distributionMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem) => void;
    updateDistributionField: typeof updateDistributionField;
    saveChanges: (distribution: IDistributionState, distributionMaintenanceGeneralDataViewData: IRepertoireComponentDataItem, lookupValues: ILookupDictionary) => void;
    undoDistribution: (distributionID: number, lookupValues: ILookupDictionary) => void;
    deleteDistribution: (distributionId: number, activeTab: number, distributionCode: string, sources: ITreeData[]) => void;
    triggerManualJob: (manualJob: ITriggerManualJob) => void;
    searchUsagePools: (query: IUsagePoolSearchQuery) => void;
    usagePools: IUsagePool[];
    allocateDistributionPools: (distribution: IDistributionState, undoAllocation: boolean) => void;
    preAllocateDistributionPools: (distribution: IDistributionState, undoPreAllocation: boolean) => void;
    setCDAllocationSchedule?: (distribution: IDistributionState, undoAllocation: boolean) => void;
    showModal: typeof showModal;
    clearModalSearchResults: typeof clearModalSearchResults;
    searchDistributionVersionHistory: (distributionId: number, lookups: ILookupDictionary, actionList: IDataActionToolbar[], formats: FormatFields[]) => void;
    exportDistributionPools: (distribution: IDistributionState, lookupValues: ILookupDictionary) => void;
    importDistributionPools: (distribution: IDistributionState, fileName: string, lookupValues: ILookupDictionary) => void;
    copyDistribution: typeof copyExistingDistribution
    getLastPercentageValues: (lastPercentageSearchQuery: ILastPercentageSearchQuery, lookups: ILookupDictionary) => void;
    sources?: ITreeData[];
    allocationJobInProgress: boolean;
    roles: string[];
    incrementTempID?: () => void;
    editableFieldsDataView?: IRepertoireComponentDataItem;
    setEditableFields: typeof setEditableFields;
    showUpdateFieldsModal: typeof showUpdateFieldsModal;
    editableFields: IRepertoireField[];
    updateComponentFieldsItems: (fields: IRepertoireField[],
        componentName: string,
        componentInstance: string,
        componentDataFieldName: string,
        tabs: ITabReduxItem[],
        activeTab: number) => void;
    getCustomer: () => void;
    getDistributionSelectionCriteriaCopy: () => void;
    customer: string;
    usagePoolsSearchResults?: IUsagePool[];
    getUsagePool: (poolId: number, matchingSources: ITreeData[]) => void;
    jobStatusQA?: string;
    runQAOnDistributionPools: (distribution: IDistributionState, undoQA: boolean) => void;
    getDistributionDetails?: (distributionID: number, lookupValues: ILookupDictionary) => void;
    upsertScheduledJob: (schedule: IScheduledJobState) => void;
    updatedScroll?: number;
    sortDistributionPoolFieldData?: typeof sortDistributionPoolFieldData;
    searchUsagePoolsByCodeDistributionPools: (query: IUsagePoolSearchQuery) => void;
    poolCodeToSearch?: string;
    updatePoolCodeToSearch?: (value: string) => void;
    resultsPerPage?: IResultsPerPage[];
    updateUserPreferences?: (
        allResultsPerPage: IResultsPerPage[],
        activeAccordions: IActiveAccordion[],
        newActiveAccordionName?: string,
        accordionExpanded?: boolean,
        componentName?: string,
        indexOfFirstResult?: number,
        indexOfLastResult?: number,
        resultsPerPage?: number,
        repertoireSection?: string
    ) => void;
    updateScheduledJobField: typeof updateScheduledJobField;
}

interface IDistributionMaintenancePageState {
    toolbarWidth: number;
    isBulkCheckboxActive?: boolean;
    checkedColumns: string[];
    showBulkCDWarning?: boolean;
    hasInvalidCD?: boolean;
}

export class DistributionMaintenancePage extends React.PureComponent<
    IDistributionMaintenancePageProps,
    IDistributionMaintenancePageState
> {
    toolbarParentRef;

    constructor(props: IDistributionMaintenancePageProps) {
        super(props);
        this.state = {
            toolbarWidth: null,
            isBulkCheckboxActive: false,
            checkedColumns: this.getCheckedHeaderFields(),
            hasInvalidCD: false
        };
        this.toolbarParentRef = React.createRef();
    }

    componentDidMount() {
        const { getCustomer, getDistributionSelectionCriteriaCopy } = this.props;
        getCustomer();
        getDistributionSelectionCriteriaCopy();

    }

    getCheckedHeaderFields = (): string[] => {
        let distributionPools = [];
        if (this.props.distribution?.distributionPools) {
            distributionPools = this.props.distribution.distributionPools;
        }

        const checkedFields: string[] = [];

        if (distributionPools.length > 0) {
            
            if (distributionPools.every(pool => pool.adjustments?.value)) {
                checkedFields.push("adjustments");
            }

            if (distributionPools.every(pool => pool.cd)) {
                checkedFields.push("continuallyDistribute");
            }

            if (distributionPools.every(pools => pools.selected)) {
                checkedFields.push("selected")
            }
        }

        return checkedFields;
    };
   

    saveDistribution() {
        const { saveChanges, distribution, distributionMaintenanceGeneralDataViewData, lookupValues } = this.props;
        saveChanges(distribution, distributionMaintenanceGeneralDataViewData, lookupValues);
        this.setState({ isBulkCheckboxActive: false });
    }

    allocateDistributionPools() {
        const { distribution, allocateDistributionPools } = this.props;
        allocateDistributionPools(distribution, false);
        this.setState({ isBulkCheckboxActive: false });
    }

    preAllocateDistributionPools() {
        const { distribution, preAllocateDistributionPools } = this.props;
        preAllocateDistributionPools(distribution, false);
        this.setState({ isBulkCheckboxActive: false });
    }
    
    undoAllocationDistributionPools() {
        const { distribution, allocateDistributionPools } = this.props;
        allocateDistributionPools(distribution, true);
        this.setState({isBulkCheckboxActive: false})
    }
    
    undoPreAllocationDistributionPools() {
        const { distribution, preAllocateDistributionPools } = this.props;
        preAllocateDistributionPools(distribution, true);
        this.setState({ isBulkCheckboxActive: false });
    }
    
    runQAOnDistributionPools = () => {
        const { distribution, runQAOnDistributionPools } = this.props;
        runQAOnDistributionPools(distribution, false);
        this.setState({ isBulkCheckboxActive: false });
    }
    setCDAllocationSchedule = () => {
        const { distribution, setCDAllocationSchedule } = this.props;
        setCDAllocationSchedule(distribution, false);
        this.setState({ isBulkCheckboxActive: false });
    }

    revertQAOnDistributionPools = () => {
        const { distribution, runQAOnDistributionPools } = this.props;
        runQAOnDistributionPools(distribution, true);
        this.setState({ isBulkCheckboxActive: false });
    }

    exportDistributionPools = () => {
        const { distribution, exportDistributionPools, lookupValues } = this.props;
        exportDistributionPools(distribution, lookupValues);
    }

    deleteDistribution() {
        const { activeTab, distribution, sources } = this.props;
        this.props.deleteDistribution(distribution.distributionID, activeTab, distribution.distributionCode, sources);
    }

    undoChanges = () => {
        const { distribution, undoDistribution, lookupValues } = this.props;
        undoDistribution(distribution.distributionID, lookupValues);
    }

    resetMessageBanner() {
        const { resetMessageBanner } = this.props;
        resetMessageBanner();
    }

    addDistributionTypeToLookup(lookupValues: ILookupDictionary): ILookupDictionary {
        const {
            distributionTypes
        } = this.props;

        if (distributionTypes === undefined) return lookupValues;
        else if (lookupValues[DISTRIBUTION_TYPE_LOOKUP] === undefined) {
            const lookups: ILookupInstance[] = [];
            distributionTypes.forEach((dt, index) => {
                const lookup: ILookupInstance = {
                    typeID: index,
                    code: dt.description,
                    description: dt.description
                };
                lookups.push(lookup);
            });
            lookupValues[DISTRIBUTION_TYPE_LOOKUP] = {
                entity: DISTRIBUTION_TYPE_LOOKUP,
                lookups: lookups,
                defaultValue: null
            };
            return lookupValues;
        }

        return lookupValues;
    }

    addDistributionSubTypeToLookup(lookupValues: ILookupDictionary): ILookupDictionary {
        const {
            distributionSubTypes
        } = this.props;

        if (distributionSubTypes === undefined) return lookupValues;
        else if (lookupValues[DISTRIBUTION_SUB_TYPE_LOOKUP] === undefined) {
            const lookups: ILookupInstance[] = [];
            distributionSubTypes.forEach((dt, index) => {
                const lookup: ILookupInstance = {
                    typeID: index,
                    code: dt.description,
                    description: dt.description
                };
                lookups.push(lookup);
            });
            lookupValues[DISTRIBUTION_SUB_TYPE_LOOKUP] = {
                entity: DISTRIBUTION_SUB_TYPE_LOOKUP,
                lookups: lookups,
                defaultValue: null
            };
            return lookupValues;
        }

        return lookupValues;
    }

    changeBulkCheckbox = (value: boolean) => {
        this.setState({ isBulkCheckboxActive: value });
    }

    toggleHeaderCheckbox = (fieldName: string, isChecked: boolean) => {
        if (fieldName === "continuallyDistribute" && isChecked) {
            const { distribution, updateDistributionField, lookupValues } = this.props;
            const pools = distribution?.distributionPools ?? [];

            const updatedPools = pools.map(pool => {
                const isInvalid = !(Number(pool.nominalValuePerPoint?.value) > 0);

                return {
                    ...pool,
                    continuallyDistribute: {
                        ...pool.continuallyDistribute,
                        value: isInvalid ? false : true
                    }
                };
            });

            const hasInvalid = updatedPools.some(pool => !pool.nominalValuePerPoint?.value || Number(pool.nominalValuePerPoint?.value) <= 0);

            if (hasInvalid) {
                updateDistributionField(updatedPools, "distributionPools", lookupValues);
                this.setState({
                    showBulkCDWarning: true,
                    checkedColumns: this.state.checkedColumns.filter(col => col !== fieldName)
                });
                return;
            }

            updateDistributionField(updatedPools, "distributionPools", lookupValues);
        }

        if(fieldName === 'selected') {
            this.setState({ isBulkCheckboxActive: isChecked })
        }

        this.setState(prevState => ({
            checkedColumns: isChecked
                ? [...new Set([...prevState.checkedColumns, fieldName])]
                : prevState.checkedColumns.filter(col => col !== fieldName),
            showBulkCDWarning: false
        }));
    };


    clearBulkCDWarning = () => {
        this.setState({ showBulkCDWarning: false });
    };


    handleRefreshDistribution = () => {
        const { distribution, lookupValues, undoDistribution } = this.props;
        undoDistribution(distribution.distributionID, lookupValues);
        this.setState({isBulkCheckboxActive: false})
    };

    render() { 
        if (this.props.distribution) {
            const {
                tabs,
                activeTab,
                distribution,
                distributionMaintenanceGeneralDataViewData,
                hideModal,
                showYesNoPrompt,
                showScheduledJobModalView,
                scheduledJobModalViewData,
                distributionMaintenanceToolbarData,
                distributionMaintenanceSaveResultData,
                addNewDistribution,
                updateDistributionField,
                dataGridTableData,
                distributionMaintenanceGridsViewData,
                searchUsagePools,
                usagePools,
                showModal,
                searchDistributionVersionHistory,
                clearModalSearchResults,
                copyDistribution,
                getLastPercentageValues,
                allocationJobInProgress,
                roles,
                triggerManualJob,
                undoDistribution,
                incrementTempID,
                editableFieldsDataView,
                setEditableFields,
                editableFields,
                showUpdateFieldsModal,
                updateComponentFieldsItems,
                customer,
                usagePoolsSearchResults,
                sources,
                getUsagePool,
                jobStatusQA,
                upsertScheduledJob,
                sortDistributionPoolFieldData,
                searchUsagePoolsByCodeDistributionPools,
                poolCodeToSearch,
                updatePoolCodeToSearch,
                resultsPerPage
            } = this.props;

            const {
                distributionPools
            } = this.props.distribution;

            let isNewDistribution: boolean = this.props.distribution.distributionID < 1 ? true : false;

            const {
                distributionSettings, subjects, distributionSubjectTypes
            } = this.props.distribution;

            const title = distribution ? distribution.distributionCode : null;

            const { updatedScroll } = this.props;

            const {
                toolbarWidth,
                isBulkCheckboxActive,
                checkedColumns,
            } = this.state;

            const changesMade = tabs[activeTab].isReadonly ? false : tabs[activeTab].changesMade;

            const isReadonly = (tabs[activeTab].isReadonly != undefined && tabs[activeTab].isReadonly);

            const hasInvalidCD = Array.isArray(distributionPools)
                ? distributionPools.some(pool =>
                    pool.continuallyDistribute?.value && !pool.nominalValuePerPoint?.value
                )
                : false;



            let { lookupValues } = this.props;

            lookupValues = this.addDistributionTypeToLookup(lookupValues);
            lookupValues = this.addDistributionSubTypeToLookup(lookupValues);

            return (
                <div>
                    <div><span className="title">{title}</span></div>
                    <If condition={tabs[activeTab].versionNumber != null}>
                        <div><span>Version history number: {tabs[activeTab].versionNumber}</span></div>
                    </If>
                    <button type="button" className="toolbar-toggle" data-toggle="collapse" data-target="#toolbarContainer">
                        <i className="icon ms-Icon ms-Icon--MoreVertical" aria-hidden="true"></i>
                    </button>
                    <div id="toolbarContainer" className="WorkMaintenanceToolbar collapse" ref={this.toolbarParentRef}>
                        <DistributionMaintenanceToolbar
                            scroll={updatedScroll}
                            toolbarWidth={toolbarWidth}
                            changesMade={changesMade}
                            saveResultData={distributionMaintenanceSaveResultData}
                            toolbarData={distributionMaintenanceToolbarData}
                            saveChanges={this.saveDistribution.bind(this)}
                            deleteDistribution={this.deleteDistribution.bind(this)}
                            resetMessageBanner={this.resetMessageBanner.bind(this)}
                            triggerManualJob={triggerManualJob}
                            undoDistribution={undoDistribution}
                            activeTab={activeTab}
                            tabs={tabs}
                            showYesNoPrompt={showYesNoPrompt}
                            showScheduledJobModalView={showScheduledJobModalView}
                            scheduledJobModalViewData={scheduledJobModalViewData}
                            hideModal={hideModal}
                            distribution={distribution}
                            isReadonly={isReadonly}
                            clearModalSearchResults={clearModalSearchResults}
                            undoDistributionChanges={this.undoChanges.bind(this)}
                            addNewDistribution={() => addNewDistribution(lookupValues, true, distributionMaintenanceGeneralDataViewData)}
                            isNew={tabs[activeTab].distributionMaintenanceState.isNew}
                            allocateDistributionPools={() => { this.allocateDistributionPools(); }}
                            preAllocateDistributionPools={() => { this.preAllocateDistributionPools(); }}
                            undoAllocationDistributionPools={() => { this.undoAllocationDistributionPools(); }}
                            undoPreAllocationDistributionPools={() => { this.undoPreAllocationDistributionPools(); }}
                            searchVersionHistory={searchDistributionVersionHistory}
                            lookupValues={lookupValues}
                            exportDistributionPools={this.exportDistributionPools}
                            showModal={showModal}
                            copyDistribution={copyDistribution}
                            allocationJobInProgress={allocationJobInProgress}
                            roles={roles}
                            jobStatusQA={jobStatusQA}
                            runQAOnDistributionPools={this.runQAOnDistributionPools}
                            revertQAOnDistributionPools={this.revertQAOnDistributionPools}
                            upsertScheduledJob={upsertScheduledJob}
                            setCDAllocationSchedule={this.setCDAllocationSchedule}
                            updateScheduledJobField={this.props.updateScheduledJobField}
                        />
                    </div>

                    <DistributionMaintenanceGeneralDataView
                        distributionMaintenanceGeneralDataViewData={distributionMaintenanceGeneralDataViewData}
                        distribution={distribution}
                        isReadonly={isReadonly}
                        lookupValues={lookupValues}
                        updateDistributionField={updateDistributionField}
                        roles={roles}
                        showUpdateFieldsModal={showUpdateFieldsModal}
                        editableFieldsDataView={editableFieldsDataView}
                        dataGridTableEditableFieldsData={dataGridTableData}
                        setEditableFields={setEditableFields}
                        editableFields={editableFields}
                        tabs={tabs}
                        activeTab={activeTab}
                        updateComponentFieldsItems={updateComponentFieldsItems}
                        customer={customer}
                        refreshDistribution={this.handleRefreshDistribution}
                    />
                    <DistributionMaintenanceGridsView
                        dataGridTableData={dataGridTableData}
                        distributionMaintenanceGridsViewData={distributionMaintenanceGridsViewData}
                        updateDistributionField={updateDistributionField}
                        lookupValues={lookupValues}
                        isReadonly={isReadonly}
                        distributionPools={distributionPools}
                        searchUsagePools={searchUsagePools}
                        distributionSettings={distributionSettings}
                        distributionSubjectTypes={distributionSubjectTypes}
                        subjects={subjects}
                        usagePools={usagePools}
                        showModal={showModal}
                        isNewDistribution={isNewDistribution}
                        getLastPercentageValues={getLastPercentageValues}
                        isBulkCheckboxActive={isBulkCheckboxActive}
                        changeBulkCheckbox={this.changeBulkCheckbox}
                        showBulkCDWarning={this.state.showBulkCDWarning}
                        clearBulkCDWarning={this.clearBulkCDWarning}
                        setHasInvalidCD={(value: boolean) => this.setState({ hasInvalidCD: value })}
                        tabs={tabs}
                        activeTab={activeTab}
                        resetMessageBanner={this.resetMessageBanner.bind(this)}
                        incrementTempID={incrementTempID}
                        usagePoolsSearchResults={usagePoolsSearchResults}
                        sources={sources}
                        getUsagePool={getUsagePool}
                        customer={customer}
                        sortDistributionPoolFieldData={sortDistributionPoolFieldData}
                        searchUsagePoolsByCodeDistributionPools={searchUsagePoolsByCodeDistributionPools}
                        poolCodeToSearch={poolCodeToSearch}
                        updatePoolCodeToSearch={updatePoolCodeToSearch}
                        checkableColumns={["adjustments", "continuallyDistribute", "selected"]}
                        checkedColumns={checkedColumns}
                        toggleHeaderCheckbox={this.toggleHeaderCheckbox}
                        resultsPerPage={resultsPerPage}
                        updateUserPreferences={this.props.updateUserPreferences}
                    />
                </div>
            );
        }
        else
            return null;
    }
}